import { forEach, merge } from "lodash";
import { createTheme } from "@mui/material";
import { themeColors } from "./theme-colors";

const themeOptions = {
  typography: {
    fontSize: 14,
    fontFamily: "Lato",
    fontWeight: 500,
    body1: {
      fontSize: "16px",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          whiteSpace: "nowrap",
        },
      },
    },
  },
};

const themes = {};

forEach(themeColors, (value, key) => {
  themes[key] = createTheme(merge({}, themeOptions, value));
});

export default themes;
